import { render } from "./SectionHeadingButton.vue?vue&type=template&id=0fe5954d"
import script from "./SectionHeadingButton.vue?vue&type=script&lang=js"
export * from "./SectionHeadingButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/SectionHeadingButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0fe5954d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0fe5954d', __exports__)) {
    api.reload('0fe5954d', __exports__)
  }
  
  module.hot.accept("./SectionHeadingButton.vue?vue&type=template&id=0fe5954d", () => {
    api.rerender('0fe5954d', render)
  })

}


export default __exports__